// This prevents the linter from complaining that localStorage doesn't exist
/* global localStorage */

import deepCopy from '../helper/deepCopy.js'

var localStorageEnabled = true

// Check if localStorage is enabled
var test = 'test'
try {
  localStorage.setItem(test, test)
  localStorage.removeItem(test)
}
catch (e) {
  localStorageEnabled = false
}

export default {
  data () {
    return {
      dataId: '',
      localStorageEnabled: false,
      userData: {}
    }
  },

  created: function () {
    if (this.dataId === '') {
      throw new Error('Component with storage mixin requires dataId to be set')
    }

    if (!this.hasOwnProperty('defaultUserData')) {
      throw new Error('Component with storage mixin requires defaultUserData to be set')
    }

    this.loadUserData()
  },

  methods: {
    // Load user data from localStorage
    loadUserData: function () {
      if (!localStorageEnabled) return

      let newData = localStorage.getItem(this.dataId)
      if (newData) this.userData = JSON.parse(newData)
      else this.userData = deepCopy(this.defaultUserData)
    },

    // Save data to localStorage
    saveUserData: function () {
      if (!localStorageEnabled) return

      let stringData = JSON.stringify(this.userData)
      localStorage.setItem(this.dataId, stringData)
    },

    // Clear user data for the current page
    clearUserData: function () {
      if (!localStorageEnabled) return

      localStorage.removeItem(this.dataId)
      this.userData = deepCopy(this.defaultUserData)
    }
  },

  watch: {
    userData: {
      handler: function (val, oldVal) {
        this.saveUserData()
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/storage.js